<template>
    <div class="">
        <BlogNotes :notes="posts"/>

        <div v-if="status.get" class="text-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>
<script>
import BlogNotes from './BlogNotes.vue';
export default {
    inject: ['axios', 'locale', 'tag'],
    components: { BlogNotes },
    data: () => ({
        posts: [],
        actualPage: 0,
        status: {
            get: false,
            finished: false
        }
    }),
    mounted() {
        this.getPosts();
        window.onscroll = (ev) => {
            if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 430)) {
                if (!this.status.get) {
                    this.getPosts();
                }
            }
        };
    },
    methods: {
        getPosts() {
            if (!this.status.get && !this.status.finished) {
                this.actualPage += 1;
                this.status.get = true;

                const queryString = new URLSearchParams(this.removeNulls({
                    page_size: 9, page: this.actualPage,
                    locale: this.locale, 'filters[tags]': this.tag,
                    include: 'banner,thumbnail'
                })).toString();

                this.axios.get(`/posts?${queryString}`).then(response => {
                    if (this.posts.length >= this.metadata?.total ) {
                        this.status.finished = true;
                    }
                    this.posts = this.posts.concat(response.data.data);
                    this.metadata = response.data.meta;
                }).catch((e) => {
                    console.warn(e)
                }).finally(() =>{
                    this.status.get = false;
                });
            }
        },

        removeNulls(obj) {
            return Object.fromEntries(
                Object.entries(obj).filter(([_, value]) => value !== null)
            );
        }
    }
}
</script>
<style scoped>
    .btn {
        text-align: left;
    }
</style>